function TextArea() {
  return <div>TextArea</div>;
}

export default TextArea;
